/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Restricts the choice of a [`PreOpsAnswer`](crate::schemas::pre_ops_answers::PreOpsAnswer)
 * 
 * [`GoodOkCritical`](PreOpsQuestionKind::GoodOkCritical) allows the choices [`Good`](crate::schemas::pre_ops_answers::PreOpsAnswerChoice::Good), [`Ok`](crate::schemas::pre_ops_answers::PreOpsAnswerChoice::Ok), and [`Critical`](crate::schemas::pre_ops_answers::PreOpsAnswerChoice::Critical). [`YesNo`](PreOpsQuestionKind::YesNo) allows the choices [`Yes`](crate::schemas::pre_ops_answers::PreOpsAnswerChoice::Yes), and [`No`](crate::schemas::pre_ops_answers::PreOpsAnswerChoice::No).
 * @export
 * @enum {string}
 */
export enum PreOpsQuestionKind {
    GOOD_OK_CRITICAL = 'goodOkCritical',
    YES_NO = 'yesNo'
}


export function instanceOfPreOpsQuestionKind(value: any): boolean {
    for (const key in PreOpsQuestionKind) {
        if (Object.prototype.hasOwnProperty.call(PreOpsQuestionKind, key)) {
            if (PreOpsQuestionKind[key as keyof typeof PreOpsQuestionKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PreOpsQuestionKindFromJSON(json: any): PreOpsQuestionKind {
    return PreOpsQuestionKindFromJSONTyped(json, false);
}

export function PreOpsQuestionKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsQuestionKind {
    return json as PreOpsQuestionKind;
}

export function PreOpsQuestionKindToJSON(value?: PreOpsQuestionKind | null): any {
    return value as any;
}

export function PreOpsQuestionKindToJSONTyped(value: any, ignoreDiscriminator: boolean): PreOpsQuestionKind {
    return value as PreOpsQuestionKind;
}

